// extracted by mini-css-extract-plugin
export default {"main":"Orders_main__Bev3T","ul":"Orders_ul__BDgvd","active":"Orders_active__mNqdR"};